/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const LTIDeepLinkResponseParser = /* #__PURE__ */ parsers.object([['url', codecString], ['jwt', codecString]]);
export class LTIDeepLinkResponse extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return LTIDeepLinkResponseParser.decode(input).map(res => new LTIDeepLinkResponse(res));
    }
    static unsafeDecode(input) {
        return LTIDeepLinkResponse.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return LTIDeepLinkResponseParser.encode(data);
    }
    static schema() {
        return LTIDeepLinkResponseParser.schema();
    }
}
